<template>
  <div id="appoint_form" @scroll.passive="getScroll($event)">
    <el-form ref="form" :model="form" label-width="200px" label-position="left" @submit.native.prevent>
       <el-card
            class="details_box-card"
            id="appoint_form"
            shadow="never"
            v-if="form.globalFieldValues[0].fieIdList.length > 0"
          >
            <div slot="header" class="clearfix">
              <div class="descicon"></div>全局问题
            </div>
            <el-form
              ref="form"
              :model="form"
              label-width="200px"
              label-position="left"
              style="width: 80%"
              @submit.native.prevent
            >
              <div v-for="(items, index) in form.globalFieldValues[0].fieIdList" :key="index">
              <el-form-item :class="{'validate-form': items.validate && items.fieIdType != 11}" v-if="!items.hide">
                <template slot="label">
                  <span style="font-weight: 700;color: #333333;" v-if="!items.fieldGroupId">
                    <span>{{items.fieIdName}}</span>
                    <span style="color: #FF4A2B;" v-if="items.isRequired == 1">*</span>
                  </span>
                  <!-- 这里可以放入任何自定义 HTML 或 Vue 组件 -->
                </template>
                <!-- 单选 -->
                <orderRadio :valueId="items.valueId" @changebox="changeGlobalBox" :index="index" :info="items" v-if="items.fieIdType == 1"></orderRadio>
                <!-- 多选 -->
                <orderCheckbox @changebox="changeGlobalBox" :index="index" :info="items" v-if="items.fieIdType == 2"></orderCheckbox>
                <!-- 单行文本 -->
                <singleText @updateValue="updateGlobalValue" :index="index" :info="items" v-if="items.fieIdType == 3"></singleText>
                <!-- 多行文本 -->
                <multilineText @updateValue="updateGlobalValue" :index="index" :info="items" v-if="items.fieIdType == 4"></multilineText>
                <!-- 富文本 -->
                <editor v-if="items.fieIdType == 5" @updateEditor="updateEditor" v-model="items.fieIdValue" :min-height="192" />
                <!-- 整数 -->
                <order-number v-if="items.fieIdType == 6" @updateValue="updateGlobalValue" :index="index" :info="items"></order-number>
                <!-- 浮点数 -->
                <order-digit v-if="items.fieIdType == 7" @updateValue="updateGlobalValue" :index="index" :info="items"></order-digit>
                <!-- 上传附件 -->
                <uploadText v-if="items.fieIdType == 8" :index="index" :isGlobal="true" :linkfileList="items.fileList" :ref="'orderfile' + index" @getFileOrder="getFile1"></uploadText>
                <!-- 数字范围 -->
                <order-range ref="orderRange" v-if="items.fieIdType == 9" @updateRange="updateGlobalRange" :index="index" :info="items"></order-range>
                <!-- 元素周期表 -->
                <div v-if="items.fieIdType == 10">
                  <div class="periodicInput" @click="selectPeriodic(items, index, indexs, true)">
                    <div>{{ items.fieIdValue }}</div>
                  </div>
                </div>
                <!-- 附件下载 -->
                <div v-if="items.fieIdType == 11">
                  <svg-icon icon-class="download" class-name="down-icon" @click="downloadFile(items)" />
                </div>
                <!-- 字段组 -->
                <order-filed-group @updateGroupValue="updateGlobalGroupValue" :global_filedGroup_list="global_filedGroup_list" :index="index" :info="items" v-if="items.fieIdType == 12"></order-filed-group>
                <!-- 时间 -->
                <group-order-duration v-if="items.fieIdType == 14" @updateRange="updateGlobalTimeValue" :index="index" :info="items"></group-order-duration>
                <!-- <div class="tipsWord">{{ items.fieIdRemark }}</div> -->
                <div class="tipsWord" v-html="items.fieIdRemark"></div>
              </el-form-item>
            </div>
        </el-form>
      </el-card>
      <div v-if="!baseFieldValuesNull">
        <el-card class="details_box-card" shadow="never" v-for="(item, index) in form.groups" :key="item + index">
          <div slot="header" class="clearfix">
            <div class="descicon"></div>
            {{ item.sampleName }}组样品
            <span v-if="index != 0" @click="delline(index)" class="deleteIcon">
              <i class="el-icon-delete"></i>
            </span>
            <div class="isShow">
              <div v-if="item.isShow" @click="tabIsShow(item)">
                <i class="el-icon-arrow-up"></i>
              </div>
              <div v-if="!item.isShow" @click="tabIsShow(item)">
                <i class="el-icon-arrow-down"></i>
              </div>
            </div>
          </div>
          <transition name="el-zoom-in-top">
            <div v-show="item.isShow" style="width: 80%" id="appoint_form">
              <el-form-item :class="{'validate-form': item.validate_specimenNum}" id="numberInput" label="样品数量" :prop="'groups.' + index + '.specimenNum'">
                <template slot="label">
                    <span style="font-weight: 700;color: #333333;">样品数量</span>
                    <span style="color: #FF4A2B;">*</span>
                    <!-- 这里可以放入任何自定义 HTML 或 Vue 组件 -->
                </template>
                <el-input-number size="small" v-model="item.specimenNum" @blur="updateSpecNum(index)" :controls="false" :min="1" :max="500"></el-input-number>
                <el-button style="margin-left: 15px;" type="success" size="small" :disabled="!item.specimenNum" @click="openSplitGroup(index)">拆分样品组</el-button>
                <el-button style="margin-left: 15px;" type="primary" size="small" @click="openUploadSpecimenCode(index)">批量导入样品编号</el-button>
              </el-form-item>
              <el-form-item :class="{'validate-form': item.validate_specimenCode}" label="样品编号" :prop="'groups.' + index + '.specimenCode'">
                <template slot="label">
                    <span style="font-weight: 700;color: #333333;">样品编号</span>
                    <span style="color: #FF4A2B;">*</span>
                    <!-- 这里可以放入任何自定义 HTML 或 Vue 组件 -->
                </template>
                <div class="specimenCode-list" v-if="item.specimenCode_list && item.specimenCode_list.length">
                  <el-input class="input-box" v-for="(i, idx) in item.specimenCode_list" :key="idx" size="small" :value="i.value" @input="editSpecimenCode($event, index, idx)"></el-input>
                </div>
                <div v-else>
                  <el-input size="small" placeholder="请输入样品数量" disabled></el-input>
                </div>
              </el-form-item>
              <el-form-item :class="{'validate-form': item.validate_specimenIngredient}" label="样品成分" :prop="'groups.' + index + '.specimenIngredient'">
                <template slot="label">
                    <span style="font-weight: 700;color: #333333;">样品成分</span>
                    <span style="color: #FF4A2B;">*</span>
                    <!-- 这里可以放入任何自定义 HTML 或 Vue 组件 -->
                </template>
                <input class="my-input" size="small" v-model="item.specimenIngredient"/>
              </el-form-item>
              <div v-for="(items, indexs) in item.fieIdList" :key="indexs">
                <el-form-item :class="{'validate-form': items.validate && items.fieIdType != 11}" v-if="!items.hide">
                  <template slot="label">
                    <span style="font-weight: 700;color: #333333;" v-if="!items.fieldGroupId">
                      <span>{{items.fieIdName}}</span>
                      <span style="color: #FF4A2B;" v-if="items.isRequired == 1">*</span>
                    </span>
                    <!-- 这里可以放入任何自定义 HTML 或 Vue 组件 -->
                  </template>
                  <!-- 单选 -->
                  <orderRadio :valueId="items.valueId" @changebox="changebox" :index="index" :info="items" v-if="items.fieIdType == 1"></orderRadio>
                  <!-- 多选 -->
                  <orderCheckbox @changebox="changebox" :index="index" :info="items" v-if="items.fieIdType == 2"></orderCheckbox>
                  <!-- 单行文本 -->
                  <singleText @updateValue="updateValue" :index="index" :info="items" v-if="items.fieIdType == 3"></singleText>
                  <!-- 多行文本 -->
                  <multilineText @updateValue="updateValue" :index="index" :info="items" v-if="items.fieIdType == 4"></multilineText>
                  <!-- 富文本 -->
                  <editor v-if="items.fieIdType == 5"  @updateEditor="updateEditor" v-model="items.fieIdValue" :min-height="192" />
                  <!-- 整数 -->
                  <order-number v-if="items.fieIdType == 6" @updateValue="updateValue" :index="index" :info="items"></order-number>
                  <!-- 浮点数 -->
                  <order-digit v-if="items.fieIdType == 7" @updateValue="updateValue" :index="index" :info="items"></order-digit>
                  <!-- 上传附件 -->
                  <uploadText v-if="items.fieIdType == 8" :index="index" :indexs="indexs" :isGlobal="false" :linkfileList="items.fileList" :ref="'orderfile' + index + indexs"
                    @getFileOrder="getFile1"></uploadText>
                  <!-- 数字范围 -->
                  <order-range v-if="items.fieIdType == 9" @updateRange="updateRange" :index="index" :info="items"></order-range>
                  <!-- 元素周期表 -->
                  <div v-if="items.fieIdType == 10">
                    <div class="periodicInput" @click="selectPeriodic(items, index, indexs, true)">
                      <div>{{ items.fieIdValue }}</div>
                    </div>
                  </div>
                  <!-- 附件下载 -->
                  <div v-if="items.fieIdType == 11">
                    <svg-icon icon-class="download" class-name="down-icon" @click="downloadFile(items)" />
                  </div>
                  <!-- 字段组 -->
                  <order-filed-group @updateGroupValue="updateGroupValue" :groups_filedGroup_list="groups_filedGroup_list[index]" :index="index" :info="items" v-if="items.fieIdType == 12"></order-filed-group>
                  <!-- 时间 -->
                  <group-order-duration v-if="items.fieIdType == 14" @updateRange="updateTimeValue" :index="index" :info="items"></group-order-duration>
                  <!-- <div class="tipsWord">{{ items.fieIdRemark }}</div> -->
                  <div class="tipsWord" v-html="items.fieIdRemark"></div>
                </el-form-item>
              </div>
            </div>
          </transition>
        </el-card>
      </div>
      <div class="addBtn" v-if="!baseFieldValuesNull">
        <el-button type="primary" icon="el-icon-circle-plus" @click="addline">增加一组样本</el-button>
      </div>
    </el-form>
    <!-- 元素周期表弹框 -->
    <periodicDialog v-if="periodicVisible" ref="periodic" @updateActive="updateActive"></periodicDialog>
    <!-- 拆分样品组弹框 -->
    <el-dialog
      title="拆分样品组"
      :visible.sync="splitGroupDialog"
      :close-on-click-modal="false"
      width="30%"
      center
      @close="closeSplitGroup">
      <div class="split-box">
        <el-checkbox-group v-model="splitGroupList">
          <el-checkbox v-for="item in splitGroupOptions" :key="item.id" :label="item">{{ item.value }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeSplitGroup">取 消 拆 分</el-button>
        <el-button type="success" :disabled="!splitGroupList.length || (splitGroupList.length == splitGroupOptions.length)" @click="confirmSplitGroup">确 定 拆 分</el-button>
      </span>
    </el-dialog>
    <!-- 批量导入样品编号 -->
    <el-dialog
      title="批量导入样品编号"
      :visible.sync="uploadSpecimenCodeDialog"
      :close-on-click-modal="false"
      width="30%"
      center
      @close="closeUploadSpecimenCode">
      <div class="uploadSpecimenCode-tips">
        <div>1、不支持特殊符号；</div>
        <div>2、多个样品编号请用逗号（“，”）区分；</div>
        <div>3、样品编号将按照您填写的顺序进行自动匹配；</div>
      </div>
      <el-input type="textarea" :rows="5" placeholder="请输入样品编号" v-model="specimenCodeText"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeUploadSpecimenCode">取 消 导 入</el-button>
        <el-button type="success" :disabled="!specimenCodeText" @click="confirmUploadSpecimenCode">确 定 导 入</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import uploadText from "../common/uploadText";
import { equipmentSubscribeFieIdList, againOrder, subscribeDraftsInfo } from '@/api/request';
import { FieldProcessing } from "./baseUtils";
import multilineText from "./components/multilineText";
import singleText from "./components/singleText";
import orderRadio from "./components/orderRadio";
import orderCheckbox from "./components/orderCheckbox";
import editor from "./components/editor";
import orderFiledGroup from "./components/orderFiledGroup/index.vue"
import orderRange from "./components/orderRange.vue";
import orderNumber from "./components/orderNumber.vue";
import orderDigit from "./components//orderDigit.vue";
import groupOrderDuration from "./components/groupOrderDuration.vue";
import periodicDialog from "./PeriodicTableOfElements/indexDialog";
export default {
  components: {
    uploadText,
    multilineText,
    singleText,
    orderRadio,
    orderCheckbox,
    editor,
    periodicDialog,
    orderFiledGroup,
    orderRange,
    orderNumber,
    orderDigit,
    groupOrderDuration
  },
  props: {
    baseFieldValuesNull: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      periodicVisible: false,
      splitGroupDialog: false,
      splitGroupIndex: undefined,
      splitGroupOptions: [],
      splitGroupList: [],
      uploadSpecimenCodeDialog: false,
      uploadSpecimenCodeIndex: undefined,
      specimenCodeText: '',
      codeList: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ],
      form: {
        //预约设备ID
        equipmentId: "",
        specimenNum: undefined,
        specimenCode: "",
        specimenIngredient: "",
        activeList: [],
        //样品组数据
        groups: [
          // {
          //   specimenNum: undefined, //样品数量
          //   specimenCode: "", //样品编号
          //   specimenIngredient: "", //样品成分
          //   fieIdList: [], //配置字段列表,
          //   sampleName: "A"
          // }
        ],
        //全局字段列表
				globalFieldValues: [
					{
						sampleName: '全局问题',
						fieIdList: [], //配置字段列表
					}
				],
      },
      groups_filedGroup_list: [],//样品组的字段组列表
      global_filedGroup_list: [],//全局字段的字段组列表
      buffetList: [],
      totalMoney: '',
      bargainStatus: false,
      bargainReminder: null,
    };
  },
  mounted() {
   
  },
  methods: {
    async init (btn,form) {
      if (btn == 'add') {
        //获取样品字段
        await this.getequipmentSubscribeFieIdList();
        //获取全局字段
        await this.getGlobalFiledList()
      } else if(btn == 'copy') {
        //获取样品字段
        await this.getequipmentSubscribeFieIdList();
        //获取全局字段
        await this.getGlobalFiledList()
        //获取再来一单/草稿箱回显数据
        let againData = undefined
        if(this.$route.query.mode == 'againOrder') {
          const againOrderRes = await againOrder(this.$route.query.orderId)
          againData = againOrderRes.data
        } else if(this.$route.query.mode == 'draftsOrder') {
          const draftsOrderRes = await subscribeDraftsInfo(this.$route.query.draftId)
          againData = JSON.parse(draftsOrderRes.data.draftsJson)
        }
        this.setAgainOrder(againData)
      } else {
        const editRes = await equipmentSubscribeFieIdList({ equipmentId: this.$route.query.id, type: 2})
        let list = FieldProcessing(editRes.data);
        list.map(i => {
          if(i.fieIdRemark){
            i.fieIdRemark = i.fieIdRemark.replace(/{br}/g, "<br/>");
          }
          if (i.fieIdType == 6 || i.fieIdType == 7 || i.fieIdType == 9) {
            i.fieIdValue = undefined
            i.fieldValueRange = undefined
          }
        })
        this.$set(this.form, 'fieIdList', list)
        let obj = JSON.parse(JSON.stringify(form))
        obj.groups.map(i=> {
          i.fieIdList.map((j,index)=> {
            j = i.values[index]
          })
          i.values.map((j,index)=> {
            j = i.values[index]
          })
        })
        this.$set(this.form, 'globalFieldValues', form.globalFieldValues)
        this.$set(this.form, 'groups', obj.groups)
        this.$forceUpdate()
        this.calculateToTalAmount()
      }
    },
    setAgainOrder(againData) {
      for(let i = 1; i < againData.groups.length; i++) {
				this.addline()
			}
			if(againData.globalFieldValues.length) {
				againData.globalFieldValues.forEach((item, index_again) => {
					const index_globalFieId = this.form.globalFieldValues[0].fieIdList.findIndex(item_globalFieId => item_globalFieId.fieIdId == item.fieIdId)
					switch(item.fieIdType) {
						case 1:
							const obj_radio = {
								fieIdValue: item.fieIdValue,
							  fieIdId: item.fieIdId,
							  optionId: item.valueId ? [Number(item.valueId)] : [],
							  options: item.options,
                valueId: item.valueId,
							}
							this.changeGlobalBox(obj_radio)
							this.form.globalFieldValues[0].fieIdList[index_globalFieId].options.forEach(item_ => {
								item_.isActive = item_.optionId == item.valueId ? true : false
							})
						break
						case 2:
                const checkbox_optionId = item.optionId ? item.optionId : item.valueId.split(',')
						    const obj_checkbox = {
						    	fieIdValue: item.fieIdValue,
						      fieIdId: item.fieIdId,
						      optionId: checkbox_optionId,
						      options: item.options,
                  valueId: checkbox_optionId.join(','),
						    }
						    this.changeGlobalBox(obj_checkbox)
						    this.form.globalFieldValues[0].fieIdList[index_globalFieId].options.forEach(item_ => {
						    	item_.isActive = item.valueId.split(',').includes(item_.optionId.toString())
						    })
						break
						case 3:
						  const obj_text_1 = {
								type: 1,
								fieIdId: item.fieIdId,
								fieIdValue: item.fieIdValue,
                index: index_again
							}
						    this.updateGlobalValue(obj_text_1)
						break
						case 4:
							const obj_text_2 = {
								type: 1,
								fieIdValue: item.fieIdValue,
						    	fieIdId: item.fieIdId,
							}
							this.updateGlobalValue(obj_text_2)
						break
						case 5:
							const obj_text_3 = {
								type: 1,
								fieIdValue: item.fieIdValue,
								fieIdId: item.fieIdId,
							}
							this.updateGlobalValue(obj_text_3)
						break
						case 6:
						    const obj_text_4 = {
						    	type: 6,
						    	fieIdValue: item.fieIdValue,
						    	fieIdId: item.fieIdId,
						    }
						    this.updateGlobalValue(obj_text_4)
						break
						case 7:
						    const obj_text_5 = {
								type: 7,
								fieIdValue: item.fieIdValue,
								fieIdId: item.fieIdId,
							}
						    this.updateGlobalValue(obj_text_5)
						break 
						case 8:
						    //上传附件字段
						break
						case 9:
						  const range_min = {
                type: 1,
                fieIdId: item.fieIdId,
                fieIdValue: item.fieIdValue,
                fieldValueRange: item.fieldValueRange,
                value: Number(item.fieldValueRange - item.fieIdValue)
							}
							const range_max = {
                type: 2,
                fieIdId: item.fieIdId,
                fieIdValue: item.fieIdValue,
                fieldValueRange: item.fieldValueRange,
                value: Number(item.fieldValueRange - item.fieIdValue)
							}
						    this.updateGlobalRange(range_min)
						    this.updateGlobalRange(range_max)
						break
						case 10:
							this.form.globalFieldValues[0].fieIdList[index_globalFieId].fieIdValue = item.fieIdValue
							this.selectPeriodic(this.form.globalFieldValues[0].fieIdList, 0, index_globalFieId, false)
						break
						case 12:
						    this.global_filedGroup_list = item.fieldGroupValues
						break
						case 14:
							item.duration = item.fieIdValue
							this.updateGlobalTimeValue(item)
						break
					}
				})
			}
			againData.groups.forEach((item_again, index_again) => {
				this.form.groups[index_again].specimenNum = item_again.specimenNum
				this.form.groups[index_again].sampleName = item_again.sampleName
				this.form.groups[index_again].specimenCode = item_again.specimenCode
				this.form.groups[index_again].specimenIngredient = item_again.specimenIngredient
        this.updateSpecNum(index_again)
				item_again.values.forEach(item => {
					const index_groupFieId = this.form.groups[index_again].fieIdList.findIndex(item_groupFieId => item_groupFieId.fieIdId == item.fieIdId)
					switch(item.fieIdType) {
						case 1:
							const obj_radio = {
							  index: index_again,
								fieIdValue: item.fieIdValue,
							  fieIdId: item.fieIdId,
							  optionId: item.valueId ? [Number(item.valueId)] : [],
							  options: item.options,
                valueId: item.valueId,
							}
							this.changebox(obj_radio)
							this.form.groups[index_again].fieIdList[index_groupFieId].options.forEach(item_ => {
								item_.isActive = item_.optionId == item.valueId ? true : false
							})
						break
						case 2:
                const checkbox_optionId = item.optionId ? item.optionId : item.valueId.split(',')
						    const obj_checkbox = {
						        index: index_again,
						    	  fieIdValue: item.fieIdValue,
						        fieIdId: item.fieIdId,
						        optionId: checkbox_optionId,
						        options: item.options,
                    valueId: checkbox_optionId.join(','),
						    }
						    this.changebox(obj_checkbox)
						    this.form.groups[index_again].fieIdList[index_groupFieId].options.forEach(item_ => {
								  item_.isActive = item.valueId.split(',').includes(item_.optionId.toString())
						    })
						break
						case 3:
						    const obj_text_1 = {
							  	  type: 1,
							  	  fieIdId: item.fieIdId,
							  	  fieIdValue: item.fieIdValue,
							  	  index: index_again
							  }
						    this.updateValue(obj_text_1)
						break
						case 4:
							const obj_text_2 = {
								type: 1,
								fieIdValue: item.fieIdValue,
						    fieIdId: item.fieIdId,
						    index: index_again
							}
							this.updateValue(obj_text_2)
						break
						case 5:
							const obj_text_3 = {
								type: 1,
								fieIdValue: item.fieIdValue,
								fieIdId: item.fieIdId,
								index: index_again
							}
							this.updateValue(obj_text_3)
						break
						case 6:
						    const obj_text_4 = {
						    	type: 6,
						    	fieIdValue: item.fieIdValue,
						    	fieIdId: item.fieIdId,
						    	index: index_again
						    }
						    this.updateValue(obj_text_4)
						break
						case 7:
						  const obj_text_5 = {
								type: 7,
								fieIdValue: item.fieIdValue,
								fieIdId: item.fieIdId,
								index: index_again
							}
						    this.updateValue(obj_text_5)
						break 
						case 8:
						    //上传附件字段
						break
						case 9:
              const range_min = {
							  index: index_again,
                type: 1,
                fieIdId: item.fieIdId,
                fieIdValue: item.fieIdValue,
                fieldValueRange: item.fieldValueRange,
                value: Number(item.fieldValueRange - item.fieIdValue)
							}
							const range_max = {
							  index: index_again,
                type: 2,
                fieIdId: item.fieIdId,
                fieIdValue: item.fieIdValue,
                fieldValueRange: item.fieldValueRange,
                value: Number(item.fieldValueRange - item.fieIdValue)
							}
						  this.updateRange(range_min)
						  this.updateRange(range_max)
						break
						case 10:
							this.form.groups[index_again].fieIdList[index_groupFieId].fieIdValue = item.fieIdValue
							this.selectPeriodic(this.form.groups[index_again].fieIdList, index_again, index_groupFieId, false)
						break
						case 12:
						  this.groups_filedGroup_list.push(item.fieldGroupValues)
						break
						case 14:
							item.index = index_again
							item.duration = item.fieIdValue
							this.updateTimeValue(item)
						break
					}
				})
			})
      const descData = {
        message: againData.message,
        customRemark: againData.customRemark,
      }
      this.$emit('updateDesc', descData)
      this.$forceUpdate()
    },
    async getequipmentSubscribeFieIdList() {
      await equipmentSubscribeFieIdList({ equipmentId: this.$route.query.id, type: 2}).then( res => {
        let list = FieldProcessing(res.data);
        list.map(i => {
          if(i.fieIdRemark){
            i.fieIdRemark = i.fieIdRemark.replace(/{br}/g, "<br/>");
          }
          if (i.fieIdType == 6 || i.fieIdType == 7 || i.fieIdType == 9) {
            i.fieIdValue = undefined
            i.fieldValueRange = undefined
          }
          if(i.fieIdType === 5){
            i.fieIdValue = i.richTextDefault
          }
          if (i.fieIdType == 10) {
            i.fieIdValue = i.needElement
          }
        })
        if(list.length) {
          this.$emit('updateBaseFieldValuesNull', false)
          this.form.fieIdList = list;
          this.addline()
          let itemList = JSON.parse(JSON.stringify(list));
          this.form.groups[0].fieIdList = itemList;
          this.form.groups[0].isShow = true;
        } else {
          this.$emit('updateBaseFieldValuesNull', true)
        }
      });
    },
    async getGlobalFiledList(){
      await equipmentSubscribeFieIdList({ equipmentId: this.$route.query.id , type: 1 }).then(
        res => {
          let list = FieldProcessing(res.data);
          list.map(i => {
            if(i.fieIdRemark){
              i.fieIdRemark = i.fieIdRemark.replace(/{br}/g, "<br/>");
            }
            if(i.fieIdType === 5){
              i.fieIdValue = i.richTextDefault
            }
            if (i.fieIdType == 6 || i.fieIdType == 7 || i.fieIdType == 9) {
              i.fieIdValue = undefined
              i.fieldValueRange = undefined
            }
          })
          // this.form.fieIdList = list;
          let itemList = JSON.parse(JSON.stringify(list));
          this.form.globalFieldValues[0].fieIdList = itemList;
        }
      );
    },
    tabIsShow(item) {
      item.isShow = !item.isShow;
      this.$forceUpdate();
    },
    getFile1(file, index, fieIdx, isGlobal) {
      if(isGlobal){
        this.form.globalFieldValues[index].fieIdList[fieIdx].fieIdValue = JSON.stringify(file)
      }else{
        this.form.groups[index].fieIdList[fieIdx].fieIdValue = JSON.stringify(file)
      }
      this.calculateToTalAmount()
    },
    getOrderFile() {
      this.form.groups.map((i, idx) => {
        if (i.fieIdList.length > 0) {
          i.fieIdList.map((j, fieIdx) => {
            if (this.$refs['orderfile' + idx + fieIdx] && this.$refs['orderfile' + idx + fieIdx].length > 0) {
              this.$refs['orderfile' + idx + fieIdx].map((m, refIdx) => {
                if (j.fieIdType == 8) {
                  m.getFile(idx,fieIdx,refIdx)
                }
              })

            }
          })
        }
      })
      this.calculateToTalAmount()
    },
    updateActive(list, groupIndex, fiedIndex,isGlobal) {
      this.activeList = list;
      let str = list.map(i => {
        return i.code;
      });
      if(isGlobal){
        this.form.globalFieldValues[0].fieIdList[
        groupIndex
      ].fieIdValue = str.toString();
      }else{
        this.form.groups[groupIndex].fieIdList[
        fiedIndex
      ].fieIdValue = str.toString();
      }
      this.$forceUpdate();
      this.calculateToTalAmount()
    },
    //富文本更新
    updateEditor(){
      this.$forceUpdate()
      this.calculateToTalAmount()
    },
    //多选组件却换
    changebox(e) {
      this.form.groups[e.index] = JSON.parse(JSON.stringify(this.$orderUtils.FieldScreen(e, this.form.groups[e.index])));
      this.$forceUpdate()
      this.calculateToTalAmount()
    },
    //全局单选/多选切换
    changeGlobalBox(e){
      this.form.globalFieldValues[0] = JSON.parse(JSON.stringify(this.$orderUtils.FieldScreen(e, this.form.globalFieldValues[0])));
      this.$forceUpdate()
      this.calculateToTalAmount()
    },
    //输入类更新数据
			updateValue(e) {
				this.form.groups[e.index] = this.$orderUtils.inputFieIdValue(e, this.form.groups[e.index]);
        this.$forceUpdate()
        this.calculateToTalAmount()
			},
      //全局输入类更新
      updateGlobalValue(e){
        this.form.globalFieldValues[0] = this.$orderUtils.inputFieIdValue(e, this.form.globalFieldValues[0]);
        this.$forceUpdate()
        this.calculateToTalAmount()
      },
      //样品时间更新
      updateTimeValue(e){
        this.form.groups[e.index] = JSON.parse(JSON.stringify(this.$orderUtils.timeValue(e, this.form.groups[e.index])));
        this.$forceUpdate()
				this.calculateToTalAmount()
			},
      //全局时间更新
      updateGlobalTimeValue(e){
        this.form.globalFieldValues[0] = JSON.parse(JSON.stringify(this.$orderUtils.timeValue(e, this.form.globalFieldValues[0])));
        this.$forceUpdate()
				this.calculateToTalAmount()
      },
      //范围组件更新数据
			updateRange(e) {
				this.form.groups[e.index] = JSON.parse(JSON.stringify(this.$orderUtils.rangeFieIdValue(e, this.form.groups[e.index])));
				this.calculateToTalAmount()
        this.$forceUpdate()
			},
      //全局范围组件更新数据
			updateGlobalRange(e) {
				this.form.globalFieldValues[0] = JSON.parse(JSON.stringify(this.$orderUtils.rangeFieIdValue(e, this.form.globalFieldValues[0])));
        this.$forceUpdate()
				this.calculateToTalAmount()
			},
      //计算金额
		calculateAmount(list,isGlobal){
			const money = JSON.parse(JSON.stringify(this.$orderUtils.getTotalMoney(list,isGlobal)))
			return money
		},
    //修改样品数量
    updateSpecNum(index) {
      // 动态计算样品编号
      const num = this.form.groups[index].specimenNum
      const list = []
      for(let i = 1; i<= num; i++) {
        const obj = {
          id: i,
          value: `${this.form.groups[index].sampleName}组样品—${i}`,
        }
        list.push(obj)
			}
      this.form.groups[index].specimenCode_list = list
      this.updateSpecimenCode(index)
      this.calculateToTalAmount()
    },
    //修改样品编号
    editSpecimenCode(e, index, idx) {
      this.form.groups[index].specimenCode_list[idx].value = e
      this.updateSpecimenCode(index)
      this.$forceUpdate()
    },
    // 打开批量导入样品编号弹框
    openUploadSpecimenCode(index) {
      this.uploadSpecimenCodeIndex = index
      this.uploadSpecimenCodeDialog = true
    },
    // 关闭批量导入样品编号弹框
    closeUploadSpecimenCode() {
      this.uploadSpecimenCodeIndex = undefined
      this.specimenCodeText = ''
      this.uploadSpecimenCodeDialog = false
    },
    // 确认批量导入
    confirmUploadSpecimenCode() {
      const value = this.specimenCodeText.replace(/，/g, ",")
      const list = value.split(',').map((item, index) => {
        return {
          id: index + 1,
          value: item,
        }
      })
      if(list[list.length - 1].value == '') {
        list.splice(list.length - 1, 1)
      }
      this.form.groups[this.uploadSpecimenCodeIndex].specimenCode_list = list
      this.form.groups[this.uploadSpecimenCodeIndex].specimenNum = list.length
      this.updateSpecimenCode(this.uploadSpecimenCodeIndex)
      this.codeChange()
      this.$forceUpdate()
      this.calculateToTalAmount()
      this.closeUploadSpecimenCode()
    },
    //打开拆分样品组弹框
    openSplitGroup(index) {
      this.splitGroupIndex = index
      this.splitGroupOptions = JSON.parse(JSON.stringify(this.form.groups[index].specimenCode_list))
      this.splitGroupDialog = true
      this.$forceUpdate()
    },
    // 关闭拆分样品组弹框
    closeSplitGroup() {
      this.splitGroupDialog = false
      this.splitGroupIndex = undefined
      this.splitGroupOptions = []
      this.splitGroupList = []
      this.$forceUpdate()
      this.calculateToTalAmount()
    },
    //确认拆分
    confirmSplitGroup() {
      this.form.groups[this.splitGroupIndex].specimenCode_list = this.form.groups[this.splitGroupIndex].specimenCode_list.filter(item => {
        const flag = this.splitGroupList.some(i => i.id == item.id)
        if(!flag) return item
      })
      this.form.groups[this.splitGroupIndex].specimenNum = this.form.groups[this.splitGroupIndex].specimenCode_list.length
      this.form.groups[this.splitGroupIndex].specimenCode = this.form.groups[this.splitGroupIndex].specimenCode_list.map(item => item.value).join(',')
      const data = JSON.parse(JSON.stringify(this.form.groups[this.splitGroupIndex]))
      data.specimenNum = this.splitGroupList.length
      data.specimenCode = this.splitGroupList.map(item => item.value).join(',')
      data.specimenCode_list = this.splitGroupList
      this.form.groups.splice(this.splitGroupIndex, 0, data)
      this.codeChange()
      this.closeSplitGroup()
    },
    //计算订单总金额
    calculateToTalAmount(){
      //计算全局金额
      let globalMoney = this.calculateAmount(this.form.globalFieldValues,true)
      //计算样品组金额
			let sampleMoney = this.calculateAmount(this.form.groups,false)
      //相加得出订单总金额
			this.totalMoney = globalMoney.totalCost + sampleMoney.totalCost
      //查询是否存在议价项目
			this.bargainStatus = false
			this.bargainReminder =  []
			if(sampleMoney.bargainReminderList.length > 0){
					this.bargainStatus = true
					this.bargainReminder = this.bargainReminder.concat(sampleMoney.bargainReminderList)
			}
			if(globalMoney.bargainReminderList.length > 0){
					this.bargainStatus = true
					this.bargainReminder = this.bargainReminder.concat(globalMoney.bargainReminderList)
			}
			if(sampleMoney.bargainReminderList.length == 0 && globalMoney.bargainReminderList.length == 0){
				this.bargainStatus = false
				this.bargainReminder = []
			}
			this.buffetList = []
			if(this.form.globalFieldValues){
				let groups = JSON.parse(JSON.stringify(this.form.globalFieldValues))
				groups.map((item,index) => {
          item.isGlobal = true
          item.totalPrice = globalMoney.totalCost
					item.subChargeVOList = globalMoney.totalList[index]
				})
				this.buffetList = this.buffetList.concat(groups)
				this.$forceUpdate()
			}
			if(this.form.groups){
				let groups = JSON.parse(JSON.stringify(this.form.groups))
				groups.map((item,index) => {
          item.isGlobal = false
          item.totalPrice = sampleMoney.totalCost
					item.subChargeVOList = sampleMoney.totalList[index]
				})
        this.buffetList = this.buffetList.concat(groups)
				this.$forceUpdate()
			}
      //组装数据返回父组件
      let obj = {
        buffetList: this.buffetList,
        globalFieldValues: this.form.globalFieldValues,
        bargainStatus: this.bargainStatus,
        bargainReminder: this.bargainReminder,
        totalMoney: this.totalMoney,
        groups: this.form.groups,
      }
      this.$emit('updateDetectionTotal', obj)
    },
    //样品组更新字段组
			updateGroupValue(e){
				this.form.groups[e.index] = this.$orderUtils.globalGroupFieIdValue(e, this.form.groups[e.index]);
        this.$forceUpdate()
				this.calculateToTalAmount()
			},
			
			//全局问题更新字段组
			updateGlobalGroupValue(e){
				this.form.globalFieldValues[0] = this.$orderUtils.globalGroupFieIdValue(e, this.form.globalFieldValues[0]);
        this.$forceUpdate()
				this.calculateToTalAmount()
			},
    selectPeriodic(items, index, indexs, flag) {
      if(flag) {
        this.periodicVisible = true;
      }
      this.$nextTick(() => {
        this.$refs.periodic.init(items, index, indexs);
      });
    },
    //附件下载
    downloadFile(items) {
      if (items.fileList.length > 0) {
        let a = document.createElement("a")
        a.href = process.env.VUE_APP_FILE_API + items.fileList[0].url
        a.download = items.fileList[0].name
        a.click()
      }

    },
    //添加一组样品
    addline() {
      let list = JSON.parse(JSON.stringify(this.form.fieIdList));
      let obj = {
        specimenNum: undefined, //样品数量
        specimenCode: "", //样品编号
        specimenIngredient: "", //样品成分
        fieIdList: list //配置字段列表
      };
      this.form.groups.push(obj);
      this.codeChange();
      this.$forceUpdate()
    },
    delline(index) {
      this.form.groups.splice(1, index);
      this.calculateToTalAmount();
      this.codeChange();
    },
    updateSpecimenCode(index) {
      this.form.groups[index].specimenCode = this.form.groups[index].specimenCode_list.map(item => item.value).join(',')
    },
    codeChange() {
      this.form.groups = this.form.groups.map((i, index) => {
        let optionValue = "";
        if (index < 26) {
          optionValue = this.codeList[index];
        } else {
          optionValue = "Z" + (index - 25);
        }
        let isShow = true;
        if (this.form.groups.length == index + 1) {
          isShow = true;
        } else {
          isShow = false;
        }
        //匹配样品编号并初始化
        if(i.specimenCode_list) {
          const regex = /^[A-Z]组样品/
          i.specimenCode_list.forEach(item => {
            item.value = item.value.replace(regex, `${optionValue}组样品`)
          })
        }
        return { ...i, sampleName: optionValue, isShow: isShow };
      });
    }
  }
};
</script>
<style>
#appoint_form .el-form-item__label {
  line-height: 20px;
}
</style>
<style scoped lang="scss">
.specimenCode-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  .input-box {
    width: 150px;
  }
}

.validate-form {
  width: 100%;
  padding: 15px;
  border: 1px solid #FF4A2B;
}

.addBtn {
  width: 100%;
  text-align: center;
  margin-bottom: 25px;
}

.details_box-card {
  margin-bottom: 30px;
}

.deleteIcon {
  color: #4d6ffe;
  cursor: pointer;
  margin-left: 10px;
}

.clearfix {
  position: relative;
}

.isShow {
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: -5px;
  font-size: 26px;
}

.periodicInput {
  cursor: pointer;
  width: 100%;
  border: 1px solid #dcdfe6;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
}

.down-icon {
  width: 60px !important;
  height: 60px !important;
  cursor: pointer;
}

.my-input {
  width: calc(100% - 35px);
  height: 30px;
  padding: 0 15px;
  border: 1px solid #DCDFE6;
  border-radius: 3px;
}
.my-input:focus {
  border: 1px solid #409EFF;
  outline: none; 
}

.uploadSpecimenCode-tips {
  margin-bottom: 10px;
  padding: 10px;
  background-color: #FFF8EB;
}
</style>